/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Bulk_Delete_Chats_SuccessInputs */



/**
* | output |
* | --- |
* | "{count} chat(s) deleted successfully." |
*
* @param {Bulk_Delete_Chats_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bulk_delete_chats_success = /** @type {((inputs: Bulk_Delete_Chats_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bulk_Delete_Chats_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Chat(s) erfolgreich gelöscht.`)
	return /** @type {LocalizedString} */ (`${i?.count} chat(s) deleted successfully.`)
});